// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .locations_section {
  background-image: url("https://static.wixstatic.com/media/2b8f69_21ea74f2d90d419c82d5430bd349979c~mv2.webp/v1/fill/w_148,h_90,al_c,q_80,usm_0.66_1.00_0.01,blur_3,enc_auto/2b8f69_21ea74f2d90d419c82d5430bd349979c~mv2.webp");
  background-size: cover;
  background-position: cover;
  color: #ffffff;
} */

.locationTitle {
  font-size: 36px;
  border-bottom: 1px solid #FFE600;
  display: inline-block;
  padding-bottom: 0.5em;
  margin-top: 15px;
}
.clinicName {
  font-size: 24px;
  margin: 5px;
}
 @media (max-width: 600px) {
  .locationTitle{
    margin-top: 65px;
  }
 }
`, "",{"version":3,"sources":["webpack://./src/PAGES/LOCATIONS/COMPONENTS/index.css"],"names":[],"mappings":"AAAA;;;;;GAKG;;AAEH;EACE,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;CACC;EACC;IACE,gBAAgB;EAClB;CACD","sourcesContent":["/* .locations_section {\n  background-image: url(\"https://static.wixstatic.com/media/2b8f69_21ea74f2d90d419c82d5430bd349979c~mv2.webp/v1/fill/w_148,h_90,al_c,q_80,usm_0.66_1.00_0.01,blur_3,enc_auto/2b8f69_21ea74f2d90d419c82d5430bd349979c~mv2.webp\");\n  background-size: cover;\n  background-position: cover;\n  color: #ffffff;\n} */\n\n.locationTitle {\n  font-size: 36px;\n  border-bottom: 1px solid #FFE600;\n  display: inline-block;\n  padding-bottom: 0.5em;\n  margin-top: 15px;\n}\n.clinicName {\n  font-size: 24px;\n  margin: 5px;\n}\n @media (max-width: 600px) {\n  .locationTitle{\n    margin-top: 65px;\n  }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
